import { createSelector } from 'reselect';

import {
  learningYearAveragePerformanceSelector,
  learningYearFinalPerformanceSelector,
} from './learningYearPerformanceSelector';

export const isPerformanceWidgetHasDataSelector = createSelector(
  [learningYearFinalPerformanceSelector, learningYearAveragePerformanceSelector],
  (finalPerformance, averagePerformance) => {
    const hasFinalPerformanceData = [finalPerformance.content].some((performance) => {
      const hasLearningYears = performance.length > 0;
      const hasAnySubjects = performance.flatMap((p) => p.subjects).length > 0;

      return hasLearningYears || hasAnySubjects;
    });

    const hasAveragePerformanceData = averagePerformance.content.subjectsPerformance.length > 0;

    return hasFinalPerformanceData || hasAveragePerformanceData;
  },
);
